/**
 * Created by Tiger on 04/03/2022.
 */
import { Form, Input } from 'antd';
import React from 'react';
import { SearchOutlined } from '@ant-design/icons';

export const InputItem = item => {
  const { label = '', style = {}, onChange, onSearch, showSearch = false, ...inputParams } = item;
  return (<Form.Item required={true} style={{ marginTop: label ? 15 : 0, ...style }}>
    <label>{label}</label>
    <Input
      style={{ marginTop: label ? 10 : 0 }}
      {...inputParams}
      onChange={event => onChange?.(event)}
      onPressEnter={event => onSearch?.(event?.target?.value, event)}
      allowClear={true}
      suffix={showSearch ? (
        <SearchOutlined
          style={{ color: '#bfbfbf', cursor: 'pointer' }}
          onClick={() => onSearch?.(inputParams.value)}
        />
      ) : null}
    />
  </Form.Item>);
};